import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Select } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TextField from '../../global/fields/TextField';
import AddIcon from '../../Icons/AddIcon';
import CrossWithBgIcon from '../../Icons/CrossWitBgIcon';
import EventIcon from '../../Icons/EventIcon';
import TimeIcon from '../../Icons/TimeIcon';
import DatepickerField from '../../global/fields/DatepickerField';
import GroupPlaceholder from '../../../assets/images/group_placeholder.svg';
import Button from '../../global/Button';
import ImageApi from '../../../api/image';
import { TranslateApi } from '../../../api';

class CreateFeedItemEvent extends Component {
  constructor(props) {
    super(props);

    this.fileInputRef = React.createRef();

    this.state = {
      title: {
        value: '',
        error: null,
      },
      location: {
        value: '',
        error: null,
      },
      description: {
        value: '',
        error: null,
      },
      startDate: {
        value: '',
        error: null,
      },
      startTime: {
        value: '',
        error: '',
      },
      endDate: {
        value: '',
        error: '',
      },
      endTime: {
        value: '',
        error: '',
      },
      imageFile: null,
      imageBlobUrl: '',
      isEndTimeAdded: false,
      language: '',
      supportedLanguages: [],
    };
  }

  async componentDidMount() {
    const result = await TranslateApi.getSupportedLanguages()
    if (result && result.success) {
      this.setState({
        supportedLanguages: result.data
      })
    }

    if (!this.props.currentEvent || (this.props.currentEvent && !this.props.currentEvent.post)) return null;

    const { title, location, description, startDate, start_time, endDate, end_time, image, image_id } =
      this.props.currentEvent.post;

    this.setState({
      title: {
        value: title,
        error: null,
      },
      location: {
        value: location,
        error: null,
      },
      description: {
        value: description,
        error: null,
      },
      startDate: {
        value: start_time,
        error: null,
      },
      startTime: {
        value: start_time,
        error: '',
      },
      endDate: {
        value: end_time,
        error: '',
      },
      endTime: {
        value: end_time,
        error: '',
      },
      isEndTimeAdded: end_time ? true : false,
    });

    if (image) {
      ImageApi.getImage(image.url).then((img) => {
        this.setState({
          imageBlobUrl: img,
          image_id: image_id,
        });
      });
    }
  }

  _onManageAttachmentClick = () => {
    this.fileInputRef.current.click();
  };

  _onFileSelect = event => {
    this.setState({
      imageFile: event.target.files[0],
      imageBlobUrl: URL.createObjectURL(event.target.files[0]),
    });
  };

  _toggleEndTime = () => {
    this.setState({ isEndTimeAdded: !this.state.isEndTimeAdded });
  };

  _submit = () => {
    if (typeof this.props.onSubmit !== 'function') return;

    const {
      title,
      description,
      location,
      startDate,
      startTime,
      isEndTimeAdded,
      endDate,
      endTime,
      imageFile,
      image_id,
    } = this.state;

    const startD = moment(startDate.value);
    const startT = new Date(startTime.value);
    startD.hours(startT.getHours());
    startD.minutes(startT.getMinutes());

    const data = {
      title,
      description,
      location,
      image_id: image_id,
      start_time: {
        value: startD.toDate().toUTCString(),
        error: startDate.error || startTime.error,
      },
    };

    if (imageFile) data.image = imageFile;

    if (isEndTimeAdded) {
      const endD = moment(endDate.value);
      const endT = new Date(endTime.value);
      endD.hours(endT.getHours());
      endD.minutes(endT.getMinutes());

      data.end_time = { value: endD.toDate().toUTCString(), error: endDate.error || endTime.error };
    }

    this.props.onSubmit('Event', data);
  };

  _shouldShowButton = () => {
    if (typeof this.props.checkFields !== 'function') return;

    const {
      title,
      description,
      location,
      startDate,
      startTime,
      isEndTimeAdded,
      endDate,
      endTime,
      imageFile,
    } = this.state;

    const startD = moment(startDate.value);
    const startT = new Date(startTime.value);
    startD.hours(startT.getHours());
    startD.minutes(startT.getMinutes());

    const data = {
      title,
      description,
      location,
      start_time: {
        value: startD.toDate().toUTCString(),
        error: startDate.error || startTime.error,
      },
    };

    if (imageFile) data.image = imageFile;

    if (isEndTimeAdded) {
      const endD = moment(endDate.value);
      const endT = new Date(endTime.value);
      endD.hours(endT.getHours());
      endD.minutes(endT.getMinutes());

      data.end_time = { value: endD.toDate().toUTCString(), error: endDate.error || endTime.error };
    }

    return this.props.checkFields('Event', data);
  };

  renderOptions (data) {
    const options = [];

    for (let i = 0; i < data.length; i++) {
      options.push(
        <Select.Option key={`lengthDur:${data[i].value}`} value={data[i].value}>
          <div className='create-feed-select-dropdown-option'>
            {data[i].label}
          </div>
        </Select.Option>,
      );
    }

    return options;
  }

  _translate = async() => {
    const {title, location, description, language} = this.state
    let translatedTitle, translatedDescription, translatedLocation;

    const resultTitle = await TranslateApi.getTranslation(language, title.value)
    if (resultTitle && resultTitle.success) {
      translatedTitle = resultTitle.data
    }

    const resultLocation = await TranslateApi.getTranslation(language, location.value)
    if (resultLocation && resultLocation.success) {
      translatedLocation = resultLocation.data
    }

    const resultDescription = await TranslateApi.getTranslation(language, description.value)
    if (resultDescription && resultDescription.success) {
      translatedDescription = resultDescription.data
    }

    if (!translatedDescription || !translatedLocation || !translatedTitle) {
      this.props.addAlertToAlerts({
        title: 'Message',
        message: 'Translation to your selected language is not currently available.',
        confirmBtnText: 'Okay',
      });
    } else {
      this.setState({
        title: {value: translatedTitle},
        description: {value: translatedDescription},
        location: {value: translatedLocation},
      })
    }
  }

  _onSupportedLanguageChange = newValue => {
    this.setState({ language: newValue });
    this.select.blur();
  };

  render() {
    const { startDate, startTime } = this.state;
    const showButton = this._shouldShowButton();
    return (
      <div className="create-feed-extra-block create-feed-event-content">
        <div className="create-feed-event-image-holder">
          {this.state.imageBlobUrl ? (
            <img
              src={this.state.imageBlobUrl}
              className="create-feed-event-image"
              alt="attachment"
            />
          ) : (
            <img
              src={GroupPlaceholder}
              className="create-feed-event-image-placeholder"
              alt="placeholder"
              width="88"
            />
          )}

          <input
            type="file"
            style={{ display: 'none' }}
            ref={this.fileInputRef}
            onChange={this._onFileSelect}
          />
        </div>

        <div
          className="create-feed-add-text align-self-center"
          onClick={this._onManageAttachmentClick}
        >
          <AddIcon className="create-feed-add-icon" />
          {this.state.imageBlobUrl ? 'REPLACE IMAGE' : 'ADD AN IMAGE'}
        </div>

        <TextField
          fk="title"
          value={this.state.title.value}
          updateFieldData={(fk, value, error) => this.setState({ title: { value, error } })}
          label="Event name"
          validateObj={{ requiredMax128: this.state.title.value }}
          showError={this.props.showErrors}
          triggerOnChange
        />

        <TextField
          fk="location"
          value={this.state.location.value}
          updateFieldData={(fk, value, error) => this.setState({ location: { value, error } })}
          label="Location"
          validateObj={{ required: this.state.location.value }}
          showError={this.props.showErrors}
          triggerOnChange
        />

        <TextField
          fk="description"
          value={this.state.description.value}
          updateFieldData={(fk, value, error) => this.setState({ description: { value, error } })}
          fieldTag="textarea"
          rows="3"
          label="Description"
          validateObj={{ requiredMax2048: this.state.description.value }}
          showError={this.props.showErrors}
          triggerOnChange
        />

        <div className="create-feed-time-select">
          <DatepickerField
            value={startDate.value}
            updateFieldData={(fk, value, error) => {
              const newStartDay = value ? moment(value).startOf('day') : null;

              let nextEndDate = this.state.endDate;
              let nextEndTime = this.state.endTime;

              if (newStartDay && this.state.endDate?.value) {
                const currentEndDay = moment(this.state.endDate.value).startOf('day');

                if (newStartDay.isAfter(currentEndDay, 'day')) {
                  nextEndDate = { value: null, error: null };
                  nextEndTime = { value: null, error: null };
                } else if (newStartDay.isSame(currentEndDay, 'day')) {
                  if (startTime?.value && this.state.endTime?.value) {
                    const startDT = moment(startDate.value || newStartDay)
                      .set({
                        hour: moment(startTime.value).hour(),
                        minute: moment(startTime.value).minute(),
                        second: 0,
                        millisecond: 0,
                      });

                    const endDT = moment(this.state.endDate.value)
                      .set({
                        hour: moment(this.state.endTime.value).hour(),
                        minute: moment(this.state.endTime.value).minute(),
                        second: 0,
                        millisecond: 0,
                      });

                    if (!endDT.isAfter(startDT)) {
                      nextEndTime = { value: null, error: null };
                    }
                  } else {
                    nextEndTime = { value: null, error: null };
                  }
                }
              }

              this.setState({
                startDate: { value, error },
                endDate: nextEndDate,
                endTime: nextEndTime,
              });
            }}
            label="Start Date"
            icon={EventIcon}
            optionalParams={{
              dateFormat: 'dd MMM yy',
              minDate: new Date(),
            }}
            validateObj={{ dateIsFuture: startDate.value }}
            showError={this.props.showErrors}
            error={startDate.error}
          />

          <DatepickerField
            value={startTime.value}
            updateFieldData={(fk, value, error) => {
              let nextEndDate = this.state.endDate;
              let nextEndTime = this.state.endTime;

              if (startDate?.value && this.state.endDate?.value) {
                const sDay = moment(startDate.value).startOf('day');
                const eDay = moment(this.state.endDate.value).startOf('day');

                if (sDay.isAfter(eDay, 'day')) {
                  nextEndDate = { value: null, error: null };
                  nextEndTime = { value: null, error: null };
                } else if (sDay.isSame(eDay, 'day')) {
                  if (value && nextEndTime?.value) {
                    const startDT = moment(startDate.value).set({
                      hour: moment(value).hour(),
                      minute: moment(value).minute(),
                      second: 0,
                      millisecond: 0,
                    });

                    const endDT = moment(this.state.endDate.value).set({
                      hour: moment(nextEndTime.value).hour(),
                      minute: moment(nextEndTime.value).minute(),
                      second: 0,
                      millisecond: 0,
                    });

                    if (!endDT.isAfter(startDT)) {
                      nextEndTime = { value: null, error: null };
                    }
                  }
                }
              }

              this.setState({
                startTime: { value, error },
                endDate: nextEndDate,
                endTime: nextEndTime,
              });
            }}
            label="Start Time"
            icon={TimeIcon}
            optionalParams={{
              showTimeSelect: true,
              showTimeSelectOnly: true,
              timeCaption: 'Time',
              dateFormat: 'HH:mm',
              timeFormat: 'HH:mm',
              minTime:
                startDate.value && moment(startDate.value).isSame(moment(), 'day')
                  ? moment().toDate()
                  : moment().startOf('day').toDate(),
              maxTime: moment().endOf('day').toDate(),
            }}
            validateObj={{
              required: startTime.value,
              timeIsFuture: moment(startDate.value)
                .set({
                  hour: moment(startTime.value).hour(),
                  minute: moment(startTime.value).minute(),
                  second: 0,
                  millisecond: 0,
                })
                .toISOString(),
            }}
            showError={this.props.showErrors}
            error={startTime.error}
          />
        </div>

        {this.renderEndTime()}

        {this.state.supportedLanguages.length ? (
          <>
            <div className='create-feed-translation-holder'>
              <span
                className={`create-feed-select-label ${
                  this.state.selectActive || this.state.language ? 'active' : ''
                }`}
                onClick={() => this.select.focus()}
              >
                Supported languages
              </span>

              <Select
                ref={ref => (this.select = ref)}
                value={this.state.language}
                onChange={this._onSupportedLanguageChange}
                className='create-feed-select'
                showArrow={false}
                dropdownClassName='create-feed-select-dropdown'
                defaultActiveFirstOption={false}
                open={this.state.selectActive}
                onFocus={() => this.setState({ selectActive: true })}
                onBlur={() => this.setState({ selectActive: false })}
              >
                {this.renderOptions(this.state.supportedLanguages)}
              </Select>

              <FontAwesomeIcon className='create-feed-select-icon' icon={['fas', 'chevron-down']} />
            </div>
            <div className="create-feed-post-button">
              <Button.Primary onClick={this._translate} disabled={!showButton || !this.state.language}>
                Translate
              </Button.Primary>
            </div>
          </>
        ) : (null)}

        <div className="create-feed-post-button">
          <Button.Primary onClick={this._submit} type="submit" disabled={!showButton}>
            {this.props.eventId ? "SAVE" : "CREATE"}
          </Button.Primary>
        </div>
        <div className="create-feed-empty-space" />
      </div>
    );
  }

  renderEndTime() {
    const { isEndTimeAdded, endDate, endTime, startDate, startTime } = this.state;

    if (!isEndTimeAdded) {
      return (
        <div className="create-feed-add-text align-self-end" onClick={this._toggleEndTime}>
          <AddIcon className="create-feed-add-icon" />
          ADD AN OPTIONAL END TIME
        </div>
      );
    }

    return (
      <div className="create-feed-time-select-extra">
        <div className="create-feed-time-select">
          <DatepickerField
            value={endDate.value}
            updateFieldData={(fk, value, error) => {
              const now = moment();
              const startDay = startDate?.value ? moment(startDate.value) : null;
              const pickedEndDay = value ? moment(value) : null;

              let nextEndTime = this.state.endTime;

              if (pickedEndDay) {
                let minEndMoment = pickedEndDay.clone().startOf('day');

                if (pickedEndDay.isSame(now, 'day')) minEndMoment = now;
                if (startDay && pickedEndDay.isSame(startDay, 'day') && startTime?.value) {
                  const startDT = startDay.clone().set({
                    hour: moment(startTime.value).hour(),
                    minute: moment(startTime.value).minute(),
                    second: 0,
                    millisecond: 0,
                  });
                  minEndMoment = moment.max(minEndMoment, startDT);
                }

                if (nextEndTime?.value) {
                  const endDT = pickedEndDay.clone().set({
                    hour: moment(nextEndTime.value).hour(),
                    minute: moment(nextEndTime.value).minute(),
                    second: 0,
                    millisecond: 0,
                  });
                  if (endDT.isBefore(minEndMoment)) {
                    nextEndTime = { value: null, error: null };
                  }
                }
              }

              this.setState({
                endDate: { value, error: null },
                endTime: nextEndTime,
              });
            }}
            label="End Date"
            icon={EventIcon}
            optionalParams={{
              dateFormat: 'dd MMM yy',
              minDate: moment.max(
                moment().startOf('day'),
                startDate?.value ? moment(startDate.value).startOf('day') : moment().startOf('day')
              ).toDate(),
            }}
            validateObj={{}} 
            showError={this.props.showErrors}
            error={endDate.error}
          />

          <DatepickerField
            value={endTime.value}
            updateFieldData={(fk, value, error) => {
              this.setState({ endTime: { value, error } });
            }}
            label="End Time"
            icon={TimeIcon}
            optionalParams={{
              showTimeSelect: true,
              showTimeSelectOnly: true,
              timeCaption: 'Time',
              dateFormat: 'HH:mm',
              timeFormat: 'HH:mm',
              minTime: (() => {
                const now = moment();
                const eDay = endDate?.value ? moment(endDate.value) : null;
                if (!eDay) return moment().startOf('day').toDate();

                let min = eDay.clone().startOf('day');

                if (eDay.isSame(now, 'day')) min = now;

                if (startDate?.value && eDay.isSame(moment(startDate.value), 'day') && startTime?.value) {
                  const startDT = moment(startDate.value).set({
                    hour: moment(startTime.value).hour(),
                    minute: moment(startTime.value).minute(),
                    second: 0,
                    millisecond: 0,
                  });
                  min = moment.max(min, startDT);
                }

                return min.toDate();
              })(),
              maxTime: moment().endOf('day').toDate(),
            }}
            validateObj={{
              dateIsLater: moment(endDate.value)
                .set({
                  hour: moment(endTime.value).hour(),
                  minute: moment(endTime.value).minute(),
                  second: 0,
                  millisecond: 0,
                })
                .toISOString(),
              startDate: moment(startDate.value)
                .set({
                  hour: moment(startTime.value).hour(),
                  minute: moment(startTime.value).minute(),
                  second: 0,
                  millisecond: 0,
                })
                .toISOString(),
            }}
            showError={this.props.showErrors}
            error={endTime.error}
          />
        </div>

        <div className="create-feed-time-cancel" onClick={this._toggleEndTime}>
          <CrossWithBgIcon />
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  currentEvent: state.events.singleEvent,
}))(CreateFeedItemEvent);

